import { suspendedComponentFactory } from '../../SuspendedComponent/suspendedComponentFactory.jsx';

export const {
  StyledAdvertorialContentDetailsWithTheme,
  StyledAdvertorialContentDetails,
  AdvertorialContentDetails,
  advertorialContentDetailsFragment,
} = suspendedComponentFactory(() => import('./AdvertorialContentDetails.jsx'));
